// src/layers/imagery/formatCountyCoverage.js
//
// Shared formatters for the per-county coverage values carried on Series and
// Acquisition (see types.js → CountyCoverage). Pure functions, no React.

/**
 * Format an aoi_coverage_ratio (0..1) as a display string.
 *   ≥ 1.0  → "100%"     (don't print >100% even if rounding pushed us there)
 *   else   → Math.round(ratio * 100) + "%"   (no decimals)
 *   null   → null       (caller can omit the percentage)
 *
 * @param {number|null} ratio
 * @returns {string|null}
 */
export function fmtCoveragePct(ratio) {
  if (ratio == null) return null;
  if (ratio >= 1) return "100%";
  return `${Math.round(ratio * 100)}%`;
}

/**
 * Compact preview string of the top-N counties by coverage ratio. Used in the
 * acquisition-pill `title` tooltip — short, plain text, no styling.
 *
 *   "Andrews 100% · Ector 60% · Martin 40%"
 *
 * Returns null when there's nothing to show (null / empty input).
 *
 * @param {{ county: string, aoi_coverage_ratio: number|null }[]|null} counties
 * @param {number} n  Max counties to include (default 3).
 * @returns {string|null}
 */
export function topCountiesPreview(counties, n = 3) {
  if (!Array.isArray(counties) || counties.length === 0) return null;
  return counties
    .slice(0, n)
    .map((c) => {
      const pct = fmtCoveragePct(c.aoi_coverage_ratio);
      return pct ? `${c.county} ${pct}` : c.county;
    })
    .join(" · ");
}
